import React, { useRef, useState } from 'react';
import { safeCallback } from '../../../library/helpers';
import { Searchfield } from '../searchfield/searchfield';
import { AutocompleteDropdown } from './autocomplete-dropdown';
import styles from './autocomplete.module.css';
import classNames from 'classnames';
/**
 * @deprecated replaced by 'DropdownSelect/DropdownMenu/DropdownSearch'
 */
export function Autocomplete(props) {
    var _a;
    var errorMessage = (_a = props.errormessage) !== null && _a !== void 0 ? _a : 'Please search for something';
    var wrapperRef = useRef(null);
    var inputRef = useRef(null);
    var _b = useState(), currentValue = _b[0], setCurrentValue = _b[1];
    React.useEffect(function () {
        function handleScrollOutside(event) {
            if (wrapperRef && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setCurrentValue('');
                safeCallback(props.onSearch, '');
            }
        }
        window.addEventListener('scroll', handleScrollOutside);
        return function () {
            window.removeEventListener('scroll', handleScrollOutside);
        };
    }, []);
    return (React.createElement("div", { className: classNames(styles.autocompleteWrapper, "kplr_autocompleteWrapper"), ref: wrapperRef },
        React.createElement("div", { className: styles.autoCompleteInputWrapper, ref: inputRef },
            React.createElement(Searchfield, { hideIcon: props.hideIcon, variant: props.variant, label: props.label, value: currentValue, responsive: props.responsive, haserror: props.haserror, onInput: function (query) {
                    safeCallback(props.onSearch, query);
                    setCurrentValue(query);
                } }),
            !!props.haserror && React.createElement("div", { className: "fieldErrorMessage" }, errorMessage)),
        typeof props.children === 'function' && (React.createElement(AutocompleteDropdown, { zIndex: props.zIndex, borderColor: props.borderColor, backgroundColor: props.backgroundColor, fixDropdownPosition: props.fixDropdownPosition, inputRef: inputRef, onRequestClose: function () {
                if (!!inputRef.current) {
                    safeCallback(props.onSearch, '');
                    setCurrentValue('');
                }
            } }, props.children()))));
}
Autocomplete.displayName = 'Autocomplete';
export default Autocomplete;
